import { invert } from 'lodash';

export const ProductionStatusEnum = {
  Planning: 0,
  Open: 1,
  Closed: 2,
};

export const ProductionStatusKeyEnum = invert(ProductionStatusEnum);



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ProductionStatusEnum.js